module.exports = __webpack_public_path__ + "static/img/fthree.c32a3c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/fthree.png
// module id = 7OUV
// module chunks = 10